// eslint-disable-next-line no-undef
if (__webpack_public_path__.startsWith("/")) {
	// eslint-disable-next-line no-undef
	__webpack_public_path__ = window.ocm.config.resourcesHostname + __webpack_public_path__;
}
